import axios from 'axios'

class ConvertDocumentService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
* @author Adrian Montemayor
* @description Traer el documento modificado del backend
* @date 31/07/2023
* @param {String} token
* @param {Object} pdf
* @returns {Object}
* @memberof ClientService
*/
    async convertDocumentPDF(token, data) {
        let response = await axios.post(`${this.apiUrl}/convert-pdf`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })

        return response.data.data
    }

}
export { ConvertDocumentService as default }
